import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { Animations } from '../../animations/animations';

@Component({
    selector: 'web-fading-span',
    templateUrl: './fading-span.component.html',
    styleUrls: ['./fading-span.component.scss'],
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [Animations.fadeOut(150), Animations.fadeIn(50)],
})
export class FadingSpanComponent {
    @Input()
    value?: number | string;
    @Input()
    suffix?: string;
    @Input()
    prefixImg?: string;
    @Input()
    imgClass?: string;
    @Input()
    valueClass?: string;
    @Input()
    suffixClass?: string;
    @Input()
    autorizeZero?: boolean;
    @Input()
    exponentContent?: string;
    @Input()
    valueClassExponent: string = 'yellow';

    protected displayValue?: number | string;
    protected displayValueAbs?: number | string;
    protected displaySuffix?: string;
    protected displaySuffixSize = 0;
    protected hasDecimalAndBigUnit = false;

    private cdRef = inject(ChangeDetectorRef);

    public onFadeOutDone(): void {
        this.displayValue = this.value;
        this.displayValueAbs = typeof this.value === 'number' ? Math.abs(this.value) : this.value;
        this.displaySuffix = this.suffix;
        this.displaySuffixSize = this.suffix?.length ?? 0;
        if (this.displayValueAbs && this.displaySuffixSize > 1) {
            this.hasDecimalAndBigUnit = +this.displayValueAbs % 1 !== 0;
        }
        this.cdRef.detectChanges();
    }
}
